module.exports = __webpack_public_path__ + "static/media/6_8.f77365b5.png";